window.MI_BARRIO_BLANK_SHIRTS = {
  "antique cherry red": {
    "color": "Antique Cherry Red",
    "filename": "shirt-antique-cherry-red.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-antique-cherry-red.png?v=1789690239",
    "ink": "white"
  },
  "antique irish green": {
    "color": "Antique Irish Green",
    "filename": "shirt-antique-irish-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-antique-irish-green.png?v=1789690237",
    "ink": "white"
  },
  "antique jade dome": {
    "color": "Antique Jade Dome",
    "filename": "shirt-antique-jade-dome.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-antique-jade-dome.png?v=1789690239",
    "ink": "white"
  },
  "antique orange": {
    "color": "Antique Orange",
    "filename": "shirt-antique-orange.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-antique-orange.png?v=1789690219",
    "ink": "white"
  },
  "antique sapphire": {
    "color": "Antique Sapphire",
    "filename": "shirt-antique-sapphire.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-antique-sapphire.png?v=1789690220",
    "ink": "white"
  },
  "ash": {
    "color": "Ash",
    "filename": "shirt-ash.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-ash.png?v=1789690207",
    "ink": "black"
  },
  "azalea": {
    "color": "Azalea",
    "filename": "shirt-azalea.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-azalea.png?v=1789690204",
    "ink": "white"
  },
  "berry": {
    "color": "Berry",
    "filename": "shirt-berry.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-berry.png?v=1789690207",
    "ink": "white"
  },
  "black": {
    "color": "Black",
    "filename": "shirt-black.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-black.png?v=1789690203",
    "ink": "white"
  },
  "blackberry": {
    "color": "Blackberry",
    "filename": "shirt-blackberry.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-blackberry.png?v=1789690208",
    "ink": "white"
  },
  "blue dusk": {
    "color": "Blue Dusk",
    "filename": "shirt-blue-dusk.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-blue-dusk.png?v=1789690203",
    "ink": "white"
  },
  "brown savanah": {
    "color": "Brown Savanah",
    "filename": "shirt-brown-savanah.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-brown-savanah.png?v=1789690234",
    "ink": "white"
  },
  "cardinal": {
    "color": "Cardinal",
    "filename": "shirt-cardinal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-cardinal.png?v=1789690237",
    "ink": "white"
  },
  "carolina blue": {
    "color": "Carolina Blue",
    "filename": "shirt-carolina-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-carolina-blue.png?v=1789690205",
    "ink": "white"
  },
  "charcoal": {
    "color": "Charcoal",
    "filename": "shirt-charcoal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-charcoal.png?v=1789690203",
    "ink": "white"
  },
  "cobalt": {
    "color": "Cobalt",
    "filename": "shirt-cobalt.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-cobalt.png?v=1789690227",
    "ink": "white"
  },
  "coral silk": {
    "color": "Coral Silk",
    "filename": "shirt-coral-silk.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-coral-silk.png?v=1789690203",
    "ink": "white"
  },
  "cornsilk": {
    "color": "Cornsilk",
    "filename": "shirt-cornsilk.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-cornsilk.png?v=1789690202",
    "ink": "black"
  },
  "daisy": {
    "color": "Daisy",
    "filename": "shirt-daisy.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-daisy.png?v=1789690203",
    "ink": "black"
  },
  "dark chocolate": {
    "color": "Dark Chocolate",
    "filename": "shirt-dark-chocolate.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-dark-chocolate.png?v=1789690231",
    "ink": "white"
  },
  "dark heather": {
    "color": "Dark Heather",
    "filename": "shirt-dark-heather.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-dark-heather.png?v=1789690211",
    "ink": "white"
  },
  "dusty rose": {
    "color": "Dusty Rose",
    "filename": "shirt-dusty-rose.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-dusty-rose.png?v=1789690202",
    "ink": "black"
  },
  "electric green": {
    "color": "Electric Green",
    "filename": "shirt-electric-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-electric-green.png?v=1789690205",
    "ink": "white"
  },
  "forest green": {
    "color": "Forest Green",
    "filename": "shirt-forest-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-forest-green.png?v=1789690203",
    "ink": "white"
  },
  "garnet": {
    "color": "Garnet",
    "filename": "shirt-garnet.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-garnet.png?v=1789690204",
    "ink": "white"
  },
  "gold": {
    "color": "Gold",
    "filename": "shirt-gold.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-gold.png?v=1789690203",
    "ink": "black"
  },
  "graphite heather": {
    "color": "Graphite Heather",
    "filename": "shirt-graphite-heather.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-graphite-heather.png?v=1789690238",
    "ink": "white"
  },
  "gravel": {
    "color": "Gravel",
    "filename": "shirt-gravel.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-gravel.png?v=1789690202",
    "ink": "white"
  },
  "heather aqua": {
    "color": "Heather Aqua",
    "filename": "shirt-heather-aqua.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-aqua.png?v=1789690230",
    "ink": "black"
  },
  "heather athletic": {
    "color": "Heather Athletic",
    "filename": "shirt-heather-athletic.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-athletic.png?v=1789690237",
    "ink": "white"
  },
  "heather autumn": {
    "color": "Heather Autumn",
    "filename": "shirt-heather-autumn.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-autumn.png?v=1789690237",
    "ink": "white"
  },
  "heather black": {
    "color": "Heather Black",
    "filename": "shirt-heather-black.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-black.png?v=1789690204",
    "ink": "white"
  },
  "heather blue": {
    "color": "Heather Blue",
    "filename": "shirt-heather-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-blue.png?v=1789690232",
    "ink": "white"
  },
  "heather blue lagoon": {
    "color": "Heather Blue Lagoon",
    "filename": "shirt-heather-blue-lagoon.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-blue-lagoon.png?v=1789690236",
    "ink": "white"
  },
  "heather brown": {
    "color": "Heather Brown",
    "filename": "shirt-heather-brown.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-brown.png?v=1789690231",
    "ink": "white"
  },
  "heather bubble gum": {
    "color": "Heather Bubble Gum",
    "filename": "shirt-heather-bubble-gum.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-bubble-gum.png?v=1789690231",
    "ink": "white"
  },
  "heather canvas red": {
    "color": "Heather Canvas Red",
    "filename": "shirt-heather-canvas-red.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-canvas-red.png?v=1789690238",
    "ink": "white"
  },
  "heather cardinal": {
    "color": "Heather Cardinal",
    "filename": "shirt-heather-cardinal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-cardinal.png?v=1789690238",
    "ink": "white"
  },
  "heather cement": {
    "color": "Heather Cement",
    "filename": "shirt-heather-cement.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-cement.png?v=1789690230",
    "ink": "black"
  },
  "heather charity pink": {
    "color": "Heather Charity Pink",
    "filename": "shirt-heather-charity-pink.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-charity-pink.png?v=1789690233",
    "ink": "black"
  },
  "heather clay": {
    "color": "Heather Clay",
    "filename": "shirt-heather-clay.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-clay.png?v=1789690235",
    "ink": "white"
  },
  "heather column blue": {
    "color": "Heather Column Blue",
    "filename": "shirt-heather-column-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-column-blue.png?v=1789690231",
    "ink": "white"
  },
  "heather cool gray": {
    "color": "Heather Cool Gray",
    "filename": "shirt-heather-cool-gray.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-cool-gray.png?v=1789690226",
    "ink": "white"
  },
  "heather dark grey": {
    "color": "Heather Dark Grey",
    "filename": "shirt-heather-dark-grey.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-dark-grey.png?v=1789690238",
    "ink": "white"
  },
  "heather deep": {
    "color": "Heather Deep",
    "filename": "shirt-heather-deep.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-deep.png?v=1789690238",
    "ink": "white"
  },
  "heather deep teal": {
    "color": "Heather Deep Teal",
    "filename": "shirt-heather-deep-teal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-deep-teal.png?v=1789690234",
    "ink": "white"
  },
  "heather dust": {
    "color": "Heather Dust",
    "filename": "shirt-heather-dust.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-dust.png?v=1789690231",
    "ink": "black"
  },
  "heather dusty blue": {
    "color": "Heather Dusty Blue",
    "filename": "shirt-heather-dusty-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-dusty-blue.png?v=1789690226",
    "ink": "black"
  },
  "heather emerald": {
    "color": "Heather Emerald",
    "filename": "shirt-heather-emerald.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-emerald.png?v=1789690234",
    "ink": "white"
  },
  "heather forest": {
    "color": "Heather Forest",
    "filename": "shirt-heather-forest.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-forest.png?v=1789690234",
    "ink": "white"
  },
  "heather grass green": {
    "color": "Heather Grass Green",
    "filename": "shirt-heather-grass-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-grass-green.png?v=1789690236",
    "ink": "white"
  },
  "heather green": {
    "color": "Heather Green",
    "filename": "shirt-heather-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-green.png?v=1789690238",
    "ink": "white"
  },
  "heather ice blue": {
    "color": "Heather Ice Blue",
    "filename": "shirt-heather-ice-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-ice-blue.png?v=1789690232",
    "ink": "black"
  },
  "heather kelly": {
    "color": "Heather Kelly",
    "filename": "shirt-heather-kelly.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-kelly.png?v=1789690237",
    "ink": "white"
  },
  "heather lapis": {
    "color": "Heather Lapis",
    "filename": "shirt-heather-lapis.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-lapis.png?v=1789690221",
    "ink": "white"
  },
  "heather magenta": {
    "color": "Heather Magenta",
    "filename": "shirt-heather-magenta.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-magenta.png?v=1789690237",
    "ink": "white"
  },
  "heather marmalade": {
    "color": "Heather Marmalade",
    "filename": "shirt-heather-marmalade.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-marmalade.png?v=1789690223",
    "ink": "white"
  },
  "heather maroon": {
    "color": "Heather Maroon",
    "filename": "shirt-heather-maroon.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-maroon.png?v=1789690238",
    "ink": "white"
  },
  "heather mauve": {
    "color": "Heather Mauve",
    "filename": "shirt-heather-mauve.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-mauve.png?v=1789690238",
    "ink": "white"
  },
  "heather midnight navy": {
    "color": "Heather Midnight Navy",
    "filename": "shirt-heather-midnight-navy.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-midnight-navy.png?v=1789690226",
    "ink": "white"
  },
  "heather military green": {
    "color": "Heather Military Green",
    "filename": "shirt-heather-military-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-military-green.png?v=1789690208",
    "ink": "white"
  },
  "heather mint": {
    "color": "Heather Mint",
    "filename": "shirt-heather-mint.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-mint.png?v=1789690237",
    "ink": "black"
  },
  "heather mustard": {
    "color": "Heather Mustard",
    "filename": "shirt-heather-mustard.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-mustard.png?v=1789690236",
    "ink": "white"
  },
  "heather navy": {
    "color": "Heather Navy",
    "filename": "shirt-heather-navy.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-navy.png?v=1789690210",
    "ink": "white"
  },
  "heather olive": {
    "color": "Heather Olive",
    "filename": "shirt-heather-olive.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-olive.png?v=1789690235",
    "ink": "white"
  },
  "heather orange bella": {
    "color": "Heather Orange Bella",
    "filename": "shirt-heather-orange-_bella.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-orange-_bella.png?v=1789690238",
    "ink": "white"
  },
  "heather orchid": {
    "color": "Heather Orchid",
    "filename": "shirt-heather-orchid.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-orchid.png?v=1789690236",
    "ink": "white"
  },
  "heather peach": {
    "color": "Heather Peach",
    "filename": "shirt-heather-peach.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-peach.png?v=1789690235",
    "ink": "black"
  },
  "heather prism blue": {
    "color": "Heather Prism Blue",
    "filename": "shirt-heather-prism-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-blue.png?v=1789690232",
    "ink": "white"
  },
  "heather prism dusty blue": {
    "color": "Heather Prism Dusty Blue",
    "filename": "shirt-heather-prism-dusty-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-dusty-blue.png?v=1789690230",
    "ink": "black"
  },
  "heather prism ice blue": {
    "color": "Heather Prism Ice Blue",
    "filename": "shirt-heather-prism-ice-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-ice-blue.png?v=1789690235",
    "ink": "black"
  },
  "heather prism lilac": {
    "color": "Heather Prism Lilac",
    "filename": "shirt-heather-prism-lilac.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-lilac.png?v=1789690227",
    "ink": "black"
  },
  "heather prism mint": {
    "color": "Heather Prism Mint",
    "filename": "shirt-heather-prism-mint.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-mint.png?v=1789690237",
    "ink": "black"
  },
  "heather prism natural": {
    "color": "Heather Prism Natural",
    "filename": "shirt-heather-prism-natural.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-natural.png?v=1789690224",
    "ink": "black"
  },
  "heather prism peach": {
    "color": "Heather Prism Peach",
    "filename": "shirt-heather-prism-peach.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-peach.png?v=1789690236",
    "ink": "black"
  },
  "heather prism sunset": {
    "color": "Heather Prism Sunset",
    "filename": "shirt-heather-prism-sunset.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-prism-sunset.png?v=1789690237",
    "ink": "white"
  },
  "heather purple": {
    "color": "Heather Purple",
    "filename": "shirt-heather-purple.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-purple.png?v=1789690234",
    "ink": "white"
  },
  "heather raspberry": {
    "color": "Heather Raspberry",
    "filename": "shirt-heather-raspberry.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-raspberry.png?v=1789690237",
    "ink": "white"
  },
  "heather rdnt orchid": {
    "color": "Heather Rdnt Orchid",
    "filename": "shirt-heather-rdnt-orchid.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-rdnt-orchid.png?v=1789690214",
    "ink": "white"
  },
  "heather red": {
    "color": "Heather Red",
    "filename": "shirt-heather-red.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-red.png?v=1789690214",
    "ink": "white"
  },
  "heather sage": {
    "color": "Heather Sage",
    "filename": "shirt-heather-sage.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-sage.png?v=1789690236",
    "ink": "white"
  },
  "heather sand dune": {
    "color": "Heather Sand Dune",
    "filename": "shirt-heather-sand-dune.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-sand-dune.png?v=1789690233",
    "ink": "black"
  },
  "heather sapphire": {
    "color": "Heather Sapphire",
    "filename": "shirt-heather-sapphire.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-sapphire.png?v=1789690239",
    "ink": "white"
  },
  "heather sea green": {
    "color": "Heather Sea Green",
    "filename": "shirt-heather-sea-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-sea-green.png?v=1789690238",
    "ink": "white"
  },
  "heather slate": {
    "color": "Heather Slate",
    "filename": "shirt-heather-slate.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-slate.png?v=1789690238",
    "ink": "white"
  },
  "heather stone": {
    "color": "Heather Stone",
    "filename": "shirt-heather-stone.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-stone.png?v=1789690235",
    "ink": "white"
  },
  "heather storm": {
    "color": "Heather Storm",
    "filename": "shirt-heather-storm.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-storm.png?v=1789690238",
    "ink": "white"
  },
  "heather sunset": {
    "color": "Heather Sunset",
    "filename": "shirt-heather-sunset.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-sunset.png?v=1789690237",
    "ink": "white"
  },
  "heather tan": {
    "color": "Heather Tan",
    "filename": "shirt-heather-tan.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-tan.png?v=1789690236",
    "ink": "white"
  },
  "heather team purple": {
    "color": "Heather Team Purple",
    "filename": "shirt-heather-team-purple.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-team-purple.png?v=1789690231",
    "ink": "white"
  },
  "heather true royal": {
    "color": "Heather True Royal",
    "filename": "shirt-heather-true-royal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-true-royal.png?v=1789690234",
    "ink": "white"
  },
  "heather yellow": {
    "color": "Heather Yellow",
    "filename": "shirt-heather-yellow.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-yellow.png?v=1789690237",
    "ink": "black"
  },
  "heather yellow gold": {
    "color": "Heather Yellow Gold",
    "filename": "shirt-heather-yellow-gold.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heather-yellow-gold.png?v=1789690238",
    "ink": "black"
  },
  "heliconia": {
    "color": "Heliconia",
    "filename": "shirt-heliconia.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-heliconia.png?v=1789690205",
    "ink": "white"
  },
  "hiviz safety green": {
    "color": "Hiviz Safety Green",
    "filename": "shirt-hiviz-safety-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-hiviz-safety-green.png?v=1789690238",
    "ink": "black"
  },
  "hiviz safety orange": {
    "color": "Hiviz Safety Orange",
    "filename": "shirt-hiviz-safety-orange.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-hiviz-safety-orange.png?v=1789690207",
    "ink": "white"
  },
  "ice grey": {
    "color": "Ice Grey",
    "filename": "shirt-ice-grey.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-ice-grey.png?v=1789690203",
    "ink": "black"
  },
  "indigo blue": {
    "color": "Indigo Blue",
    "filename": "shirt-indigo-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-indigo-blue.png?v=1789690203",
    "ink": "white"
  },
  "irish green": {
    "color": "Irish Green",
    "filename": "shirt-irish-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-irish-green.png?v=1789690237",
    "ink": "white"
  },
  "kiwi": {
    "color": "Kiwi",
    "filename": "shirt-kiwi.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-kiwi.png?v=1789690238",
    "ink": "white"
  },
  "light blue": {
    "color": "Light Blue",
    "filename": "shirt-light-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-light-blue.png?v=1789690238",
    "ink": "black"
  },
  "light pink": {
    "color": "Light Pink",
    "filename": "shirt-light-pink.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-light-pink.png?v=1789690203",
    "ink": "black"
  },
  "lilac": {
    "color": "Lilac",
    "filename": "shirt-lilac.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-lilac.png?v=1789690224",
    "ink": "black"
  },
  "lime": {
    "color": "Lime",
    "filename": "shirt-lime.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-lime.png?v=1789690216",
    "ink": "black"
  },
  "maroon": {
    "color": "Maroon",
    "filename": "shirt-maroon.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-maroon.png?v=1789690239",
    "ink": "white"
  },
  "midnight": {
    "color": "Midnight",
    "filename": "shirt-midnight.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-midnight.png?v=1789690225",
    "ink": "white"
  },
  "military": {
    "color": "Military",
    "filename": "shirt-military.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-military.png?v=1789690239",
    "ink": "white"
  },
  "mint green": {
    "color": "Mint Green",
    "filename": "shirt-mint-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-mint-green.png?v=1789690221",
    "ink": "black"
  },
  "natural": {
    "color": "Natural",
    "filename": "shirt-natural.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-natural.png?v=1789690217",
    "ink": "black"
  },
  "navy": {
    "color": "Navy",
    "filename": "shirt-navy.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-navy.png?v=1789690235",
    "ink": "white"
  },
  "neon blue": {
    "color": "Neon Blue",
    "filename": "shirt-neon-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-neon-blue.png?v=1789690221",
    "ink": "white"
  },
  "neon green": {
    "color": "Neon Green",
    "filename": "shirt-neon-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-neon-green.png?v=1789690221",
    "ink": "white"
  },
  "old gold": {
    "color": "Old Gold",
    "filename": "shirt-old-gold.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-old-gold.png?v=1789690222",
    "ink": "black"
  },
  "orange": {
    "color": "Orange",
    "filename": "shirt-orange.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-orange.png?v=1789690219",
    "ink": "white"
  },
  "purple": {
    "color": "Purple",
    "filename": "shirt-purple.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-purple.png?v=1789690235",
    "ink": "white"
  },
  "red": {
    "color": "Red",
    "filename": "shirt-red.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-red.png?v=1789690238",
    "ink": "white"
  },
  "royal": {
    "color": "Royal",
    "filename": "shirt-royal.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-royal.png?v=1789690239",
    "ink": "white"
  },
  "russett": {
    "color": "Russett",
    "filename": "shirt-russett.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-russett.png?v=1789690228",
    "ink": "white"
  },
  "safety pink": {
    "color": "Safety Pink",
    "filename": "shirt-safety-pink.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-safety-pink.png?v=1789690223",
    "ink": "black"
  },
  "sand": {
    "color": "Sand",
    "filename": "shirt-sand.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-sand.png?v=1789690237",
    "ink": "black"
  },
  "sapphire": {
    "color": "Sapphire",
    "filename": "shirt-sapphire.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-sapphire.png?v=1789690239",
    "ink": "white"
  },
  "sky": {
    "color": "Sky",
    "filename": "shirt-sky.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-sky.png?v=1789690239",
    "ink": "white"
  },
  "solid white blend": {
    "color": "Solid White Blend",
    "filename": "shirt-solid-white-blend.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-solid-white-blend.png?v=1789690234",
    "ink": "black"
  },
  "sport grey": {
    "color": "Sport Grey",
    "filename": "shirt-sport-grey.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-sport-grey.png?v=1789690230",
    "ink": "black"
  },
  "sunset": {
    "color": "Sunset",
    "filename": "shirt-sunset.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-sunset.png?v=1789690239",
    "ink": "white"
  },
  "tennessee orange": {
    "color": "Tennessee Orange",
    "filename": "shirt-tennessee-orange.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-tennessee-orange.png?v=1789690230",
    "ink": "white"
  },
  "texas orange": {
    "color": "Texas Orange",
    "filename": "shirt-texas-orange.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-texas-orange.png?v=1789690229",
    "ink": "white"
  },
  "tropical blue": {
    "color": "Tropical Blue",
    "filename": "shirt-tropical-blue.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-tropical-blue.png?v=1789690230",
    "ink": "white"
  },
  "turf green": {
    "color": "Turf Green",
    "filename": "shirt-turf-green.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-turf-green.png?v=1789690239",
    "ink": "white"
  },
  "tweed": {
    "color": "Tweed",
    "filename": "shirt-tweed.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-tweed.png?v=1789690233",
    "ink": "white"
  },
  "violet": {
    "color": "Violet",
    "filename": "shirt-violet.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-violet.png?v=1789690238",
    "ink": "white"
  },
  "white": {
    "color": "White",
    "filename": "shirt-white.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-white.png?v=1789690231",
    "ink": "black"
  },
  "yellow haze": {
    "color": "Yellow Haze",
    "filename": "shirt-yellow-haze.png",
    "url": "https://cdn.shopify.com/s/files/1/0745/7171/0741/files/shirt-yellow-haze.png?v=1789690233",
    "ink": "black"
  }
};